import { getLocale, getNumberFormatConfig, usesCommaDecimal } from "./service/tool-service";

const NumberUtil = {
  /**
   * 格式化數值，支援千分位分隔符和國際化小數點
   * @param {number} number - 要格式化的數值
   * @param {number} minDigits - 最小小數位數
   * @param {number} maxDigits - 最大小數位數
   * @returns {string} 格式化後的數值字串
   */
  formatWithCommas: (number, minDigits, maxDigits) => {
    if (number == null || isNaN(number)) return "";

    const str = number.toString();
    const decimalPart = str.includes(".") ? str.split(".")[1] : "";
    const autoDigits = decimalPart.length;

    const minimumFractionDigits = minDigits != null ? minDigits : autoDigits;
    const maximumFractionDigits = maxDigits != null ? maxDigits : autoDigits;

        // 獲取當前語系的數值格式配置
    const numberFormatConfig = getNumberFormatConfig();
    const usesCommaDecimalLocale = usesCommaDecimal();
    
    let formattedNumber;
    
    if (usesCommaDecimalLocale) {
      // 使用逗號小數點的語系：手動格式化，避免 Intl.NumberFormat 的千分位問題
      const parts = str.split('.');
      const integerPart = parts[0];
      const decimalPart = parts[1] || '';
      
      // 手動添加千分位分隔符
      let formattedInteger = '';
      for (let i = integerPart.length - 1, j = 0; i >= 0; i--, j++) {
        if (j > 0 && j % 3 === 0) {
          formattedInteger = numberFormatConfig.thousandsSeparator + formattedInteger;
        }
        formattedInteger = integerPart[i] + formattedInteger;
      }
      
      // 組合整數和小數部分
      if (decimalPart) {
        formattedNumber = `${formattedInteger}${numberFormatConfig.decimalSeparator}${decimalPart}`;
      } else {
        formattedNumber = formattedInteger;
      }
      
      // 處理小數位數
      if (minimumFractionDigits > 0 || maximumFractionDigits > 0) {
        const currentDecimalLength = decimalPart.length;
        if (currentDecimalLength < minimumFractionDigits) {
          // 補足最小小數位數
          const padding = '0'.repeat(minimumFractionDigits - currentDecimalLength);
          formattedNumber += padding;
        } else if (currentDecimalLength > maximumFractionDigits) {
          // 截斷到最大小數位數
          formattedNumber = formattedNumber.substring(0, formattedNumber.length - (currentDecimalLength - maximumFractionDigits));
        }
      }
    } else {
      // 使用點號小數點的語系：使用標準的 Intl.NumberFormat
      formattedNumber = new Intl.NumberFormat(getLocale(), {
        minimumFractionDigits,
        maximumFractionDigits,
      }).format(number);
    }
    
    return formattedNumber;
  },

  /**
   * 將標準格式數值轉換為當前語系格式（用於顯示）
   * @param {string|number} value - 要轉換的值
   * @returns {string} 當前語系格式的值
   */
  toLocaleFormat: (value) => {
    if (!value) return '';
    
    let stringValue = value.toString();
    const numberFormatConfig = getNumberFormatConfig();
    
    if (usesCommaDecimal() && stringValue.includes('.')) {
      // 將標準格式轉換為當前語系顯示格式
      stringValue = stringValue.replace('.', numberFormatConfig.decimalSeparator);
    }
    
    return stringValue;
  },

  /**
   * 將當前語系格式轉換為標準格式（用於 API 呼叫）
   * @param {string|number} value - 要轉換的值
   * @returns {string} 標準格式的值
   */
  toStandardFormat: (value) => {
    if (!value) return '';
    
    let stringValue = value.toString();
    const numberFormatConfig = getNumberFormatConfig();
    
    if (usesCommaDecimal() && stringValue.includes(numberFormatConfig.decimalSeparator)) {
      // 將當前語系格式轉換為標準格式
      stringValue = stringValue.replace(new RegExp(`\\${numberFormatConfig.decimalSeparator}`, 'g'), '.');
    }
    
    return stringValue;
  }
};

export default NumberUtil;
